import { type FC } from 'react';
import { Cell, ClickableIcon, IconEditFilled, VStack } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components';
import { SettingsBlockRow, type SettingsBlockRowProps } from './SettingsBlockRow';
import styles from './SettingsBlockRow.module.css';

export interface SettingsBlockRowPenProps extends SettingsBlockRowProps, TestProps {
    onChange?: () => void;
    isEditable?: boolean;
}

export const SettingsBlockRowPen: FC<SettingsBlockRowPenProps> = ({
    'data-testid': dataTestId = 'SettingsBlockRow',
    onChange,
    isEditable = true,
    ...props
}) => (
    <SettingsBlockRow {...props} data-testid={dataTestId}>
        {onChange && isEditable && (
            <Cell type="Icon" className={styles.icon}>
                <VStack>
                    <ClickableIcon data-testid={`${dataTestId}.Icon`} role="supplementary" onClick={onChange}>
                        <IconEditFilled size="20" />
                    </ClickableIcon>
                </VStack>
            </Cell>
        )}
    </SettingsBlockRow>
);
